import { listUrl } from "../Data";
import { ImageCustom } from "../Image/index";

import {
  ReportSection,
  ReportDescription,
  ReportBox,
  ReportWrapper,
  ReportVideo,
  ReportTitle,
  ReportSubTitle,
  ReportHR,
  ReportDocuments,
  ReportDocumentsBox,
  ReportDocumentsLink,
  ReportDocumentswrapper,
  ReportDocumentsLinkImg,
  ReportDocumentsTitleBox,
  ReportDocumentsTitle,
} from "./style";

const video =
  "https://player.vimeo.com/video/842884995?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";

const ReportComponent = () => {
  return (
    <ReportSection id="Relatorio-Anual">
      <ReportDescription>
        <ReportBox>
          <ImageCustom src={listUrl.report.img} alt="" />
          <ReportWrapper>
            <ReportTitle>Relatório Anual</ReportTitle>
            <ReportHR />
            <ReportSubTitle>
              Divulgamos anualmente nossas informações ambientais, sociais,
              financeiras e de governança através do nosso Relatório Anual. Para
              saber mais sobre nossas iniciativas, projetos, compromissos e
              evolução em sustentabilidade,{" "}
              <a
                href="https://ri.arezzoco.com.br/governanca-corporativa/relatorio-de-sustentabilidade/"
                target="_blank"
                rel="noreferrer"
              >
                acesse nossos relatórios.
              </a>{" "}
            </ReportSubTitle>
          </ReportWrapper>
        </ReportBox>
        <ReportVideo>
          <iframe
            src={video}
            width="815"
            height="460"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            title="Relatório Anual"
            allowFullScreen
          />
        </ReportVideo>
      </ReportDescription>
      <ReportDocumentsTitleBox id="Documentos">
        <ReportDocumentsTitle>Documentos</ReportDocumentsTitle>
      </ReportDocumentsTitleBox>
      <ReportDocuments>
        <ReportDocumentswrapper>
          <ReportDocumentsBox>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Política de sustentabilidade.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Política de Sustentabilidade Arezzo&Co
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/politica_de_sustentabilidade_jul_23.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Política de Sustentabilidade_JUL23
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Sustainability_Policy.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Sustainability Policy Arezzo&Co
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/211213_CartilhaDiversidade_Arezzo_V6.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Cartilha de Diversidade
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatório Anual de Sustentabilidade 2022.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2022
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatorio_Anual_2022_Anexo.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2022_Anexo
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatório Anual de Sustentabilidade 2021.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2021
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatório Anual de Sustentabilidade 2020.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2020
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatório Anual de Sustentabilidade 2019.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2019
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatório Anual de Sustentabilidade 2018.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2018
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Resíduos Pré e Pós Consumo.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Resíduos Pré e Pós Consumo.pdf
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Lista de Atributos-Materiais Sustentáveis.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Lista de Atributos-Materiais Sustentáveis
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/lista_de_substancias_restritas.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Lista de Substâncias Restritas
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Restricted_Substance_List.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Restricted Substance List
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Código de Conduta.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Código de Conduta
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Treinamento de Compliance_Discriminação, assédio e boas práticas.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Treinamento de Compliance_Discriminação, assédio e boas práticas
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/cadeia_de_fornecimento_arezzo&Co.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Cadeia de fornecimento-Arezzo&Co
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Lista_Fornecedores_dez23_Tier_1.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Lista de fornecedores Arezzo&Co
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/CDP_Climate_Change_Questionnaire_2023_ArezzoeCo.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              CDP_Climate_Change_Questionnaire_2023_ArezzoeCo
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/politicas_de_privacidade.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Políticas de privacidade
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/privacy_policy.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Privacy Policy
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Arezzo&Co_cartilha_antirracista_versão_digital.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Cartilha Antirracista
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Cartilha-de-comunicação_inclusiva_digital.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Cartilha de Comunicação Inclusiva
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Cartilha_Anticapacitista_Digital.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Cartilha Anticapacitista
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Resumo_da_Analise_de_Cenarios_Climaticos.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Resumo da Análise de Cenários Climáticos
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Codigo_de_Conduta_de_Fornecedores.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Código de Conduta de Fornecedores
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Estudo_de_ACV da_Alme_Tenis_Carbon_Neutral.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Estudo de ACV da Alme Tênis Carbon Neutral
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatorio_Bones_preto_e_verde.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Bonés preto e verde
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatorio_do_Tenis_Carbon_Neutral_Alme.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Carbon Neutral
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatorio_Slide_Ecoa+Lume.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Slide Ecoa + Lume
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/Relatorio_Mapa.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Mapá
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/eu_reciclo.pdf"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.icon} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Eu Reciclo
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/relatorioAnual2023_pt_arquivoAcessivel.epub"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.iconDown} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2023 PT - Arquivo acessível
            </ReportDocumentsLink>
            <ReportDocumentsLink
              href="https://www.arezzo.com.br/content/arz/sustainability-arezzo&co/documentos/relatorioAnual2023_en_arquivoAcessivel.epub"
              target="_blank"
            >
              <ReportDocumentsLinkImg>
                <ImageCustom src={listUrl.report.iconDown} alt="" />
              </ReportDocumentsLinkImg>
              Relatório Anual 2023 EN - Arquivo acessível
            </ReportDocumentsLink>
          </ReportDocumentsBox>
        </ReportDocumentswrapper>
      </ReportDocuments>
    </ReportSection>
  );
};

export default ReportComponent;
